import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import DevChampsHighestGradeRs from '@domain/rs/dchamps/DevChampsHighestGradeRs';
import DevChampsResultListRs from '@domain/rs/dchamps/DevChampsResultListRs';
import DevChampsResultTokenRs from '@domain/rs/dchamps/DevChampsResultTokenRs';
import PhsEventApplyCreateRs from '@domain/rs/dchamps/PhsEventApplyCreateRs';
import DevChampsApplyStatusRs from '@domain/rs/dchamps/DevChampsApplyStatusRs';
import DevChampsFinalsUserListRs from '@domain/rs/dchamps/DevChampsFinalsUserListRs';
import DevChampsInfoRs from '@domain/rs/dchamps/DevChampsInfoRs';
import { DchampsEventType } from '@domain/constant/dchamps/eventType';

const dChampsPrefix = '/dchamps';
export default interface DchampsRepo {
  //디챔스 정보 조회
  fetchDchampsInfo(): Promise<AxiosResponse<DevChampsInfoRs>>;

  //디챔스 기간 내 최고 등급 조회
  fetchDchampsGrade(eventType: DchampsEventType): Promise<AxiosResponse<DevChampsHighestGradeRs>>;

  //본선 대상자 여부
  fetchDchampsFinalCheck(eventType: DchampsEventType): Promise<AxiosResponse<boolean>>;

  //디챔스 랭킹 조회
  fetchDchampsRanks(eventType: DchampsEventType): Promise<AxiosResponse<DevChampsFinalsUserListRs>>;

  //디챔스 결과표 리스트 조회
  fetchDchampsResults(): Promise<AxiosResponse<DevChampsResultListRs>>;

  //디챔스 결과표 url, 토큰 발급
  fetchDchampsResultsToken(sn: number): Promise<AxiosResponse<DevChampsResultTokenRs>>;

  //디챔스 본선 응시 코드 생성
  createDchampsFinalsApply(eventType: DchampsEventType): Promise<AxiosResponse<PhsEventApplyCreateRs>>;

  //디챔스 응시 여부 조회
  fetchDchampsApplyStatus(eventType: DchampsEventType): Promise<AxiosResponse<DevChampsApplyStatusRs>>;
}

export class RemoteDchampsRepo implements DchampsRepo {
  fetchDchampsInfo(): Promise<AxiosResponse<DevChampsInfoRs>> {
    return axios.get(`${dChampsPrefix}/v2/info`);
  }

  fetchDchampsGrade(eventType: DchampsEventType): Promise<AxiosResponse<DevChampsHighestGradeRs>> {
    return axios.get(`${dChampsPrefix}/v2/grade`, { params: { eventType } });
  }

  fetchDchampsFinalCheck(eventType: DchampsEventType): Promise<AxiosResponse<boolean>> {
    return axios.get(`${dChampsPrefix}/v2/finals/user/status`, {
      params: { eventType },
    });
  }

  fetchDchampsRanks(eventType: DchampsEventType): Promise<AxiosResponse<DevChampsFinalsUserListRs>> {
    return axios.get(`${dChampsPrefix}/v2/finals/user/list`, { params: { eventType } });
  }

  fetchDchampsResults(): Promise<AxiosResponse<DevChampsResultListRs>> {
    return axios.get(`${dChampsPrefix}/v2/results`);
  }

  fetchDchampsResultsToken(devChampsSn: number): Promise<AxiosResponse<DevChampsResultTokenRs>> {
    return axios.get(`${dChampsPrefix}/v2/results/token`, { params: { devChampsSn } });
  }

  createDchampsFinalsApply(eventType: DchampsEventType): Promise<AxiosResponse<PhsEventApplyCreateRs>> {
    return axios.get(`${dChampsPrefix}/v2/finals/apply`, { params: { eventType } });
  }

  fetchDchampsApplyStatus(eventType: DchampsEventType): Promise<AxiosResponse<DevChampsApplyStatusRs>> {
    return axios.get(`${dChampsPrefix}/v2/apply/status`, {
      params: { eventType },
    });
  }
}
